import React, { useState } from "react";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function MotivationInfo() {
    const userRole = localStorage.getItem('role'); 
    const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

    // ИЗМЕНЕНИЕ: 2. Устанавливаем начальное состояние в зависимости от роли
    // Если роль '3', по умолчанию будет 'hr_deputy', иначе — 'admin'.
    const [motivationState, setMotivationState] = useState(userRole === '3' ? 'hr_deputy' : 'admin');


    // const [motivationState, setMotivationState] = useState("admin");
    const api_url = process.env.REACT_APP_API_URL;
    const [adminFinanceInfo, setAdminFinanceInfo] = useState([]);   
    const [cashierFinanceInfo, setCashierFinanceInfo] = useState([]);  
    const [qualityControlFinanceInfo, setQualityControlFinanceInfo] = useState([]);  
    const [washerMotivationInfo, setWasherMotivationInfo] = useState([]);

    const [showArchived, setShowArchived] = useState(false);

    React.useEffect(() => {                                         //функция, которая вызывается при загрузке страницы
        async function getAdminFinanceInfo() {
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')},
            body: JSON.stringify({ start_date: startDate, end_date: endDate })
          };
          const admin_finance_info = await fetch(api_url+"/api/adminFinanceInfo", requestOptions);
          const body = await admin_finance_info.json();
          setAdminFinanceInfo(body.map(({ admin_id, admin_name, total_cash, visits_number, shift_number, services_turnover, average_bill, admin_salary_bonus, visits_number_kpi, average_bill_rate, total_salary, average_bill_plan, advances_sum, goods_sum }) => ({ admin_id: admin_id, admin_name: admin_name, total_cash: total_cash, visits_number: visits_number, shift_number: shift_number, services_turnover: services_turnover, average_bill: average_bill, admin_salary_bonus: admin_salary_bonus, visits_number_kpi: visits_number_kpi, average_bill_rate: average_bill_rate, total_salary: total_salary, average_bill_plan: average_bill_plan, advances_sum: advances_sum, goods_sum: goods_sum })));
        }

        async function getCashierFinanceInfo() {
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')},
              body: JSON.stringify({ start_date: startDate, end_date: endDate })
            };
            const cashier_finance_info = await fetch(api_url+"/api/cashierFinanceInfo", requestOptions);
            const body = await cashier_finance_info.json();
            setCashierFinanceInfo(body.map(({ cashier_id, cashier_name, total_cash, visits_number, shift_number, total_goods, total_cert_bonus, kpi, total_goods_salary, progressive_product_count, progressive_motivation_bonus, advances_sum, goods_sum }) => ({ cashier_id: cashier_id, cashier_name: cashier_name, total_cash: total_cash, visits_number: visits_number, shift_number: shift_number, total_goods: total_goods, total_cert_bonus: total_cert_bonus, kpi: kpi, total_goods_salary: total_goods_salary, progressive_product_count: progressive_product_count, progressive_motivation_bonus: progressive_motivation_bonus, advances_sum: advances_sum, goods_sum: goods_sum })));
        }

        async function getQualityControlFinanceInfo() {
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')},
              body: JSON.stringify({ start_date: startDate, end_date: endDate })
            };
            const cashier_finance_info = await fetch(api_url+"/api/qualityControlFinanceInfo", requestOptions);
            const body = await cashier_finance_info.json();
            setQualityControlFinanceInfo(body.map(({ quality_control_id, quality_control_name, visits_number, shift_number, average_check, normal_amount, kpi, fines, salary, salary_without_kpi, bonuses, advances_sum, goods_sum }) => ({ quality_control_id: quality_control_id, quality_control_name: quality_control_name, visits_number: visits_number, average_check: average_check, normal_amount: normal_amount, shift_number: shift_number, kpi: kpi, fines: fines, salary: salary, salary_without_kpi: salary_without_kpi, bonuses: bonuses, advances_sum: advances_sum, goods_sum: goods_sum })));
        }

        async function getWasherMotivationInfo() {
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')},
              // Добавляем showArchived в тело запроса
              body: JSON.stringify({ 
                start_date: startDate, 
                end_date: endDate,
                showArchived: showArchived // <--- Наше новое состояние
              })
            };
            const response = await fetch(`${api_url}/api/washerMotivationInfo`, requestOptions);
            const body = await response.json();
            setWasherMotivationInfo(body);
        }

        if (motivationState == "admin"){
            getAdminFinanceInfo();
        }
        else if (motivationState == "cashier"){
            getCashierFinanceInfo();
        }
        else if (motivationState == "quality_control"){
            getQualityControlFinanceInfo();
        }
        else if (motivationState === "hr_deputy") {
            getWasherMotivationInfo();
        }
        }, [startDate, endDate, motivationState, showArchived, api_url]);

    React.useEffect(() => {
        if (motivationState !== 'hr_deputy') {
            setShowArchived(false);
        }
    }, [motivationState]);

    return (
        <>
            <head>
                <title>Мотивация</title>
                <meta property="og:title" content="Dashboard" key="title" />
            </head>

            <Box sx={{pt:5, pb:5}} fullWidth>
            <TextField
                id="start_date"
                label="Дата с"
                type="date"
                defaultValue={startDate}
                sx={{ m: 1.5, width: 220}}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={e => setStartDate(e.target.value)}
            />

            <TextField
                id="end_date"
                label="Дата по"
                type="date"
                defaultValue={endDate}
                sx={{ m: 1.5, width: 220 }}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={e => setEndDate(e.target.value)}
            />

            {/* ИЗМЕНЕНИЕ: 3. Оборачиваем селектор в условие */}
            {/* Этот блок будет отображаться для всех, кроме пользователя с ролью '3' */}
            {userRole !== '3' && (
                <FormControl sx={{mb:1.5, mt:1.5, width: 300}} >
                <InputLabel id="demo-simple-select-label">Выбор категории работников:</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="motivation-state"
                    name="motivationState"
                    value={motivationState}
                    label="Выбор категории работников"
                    onChange={e => setMotivationState(e.target.value)}
                >
                <MenuItem value={"admin"}>Администраторы</MenuItem>
                <MenuItem value={"cashier"}>Кассир</MenuItem>
                <MenuItem value={"quality_control"}>Контроль Качества</MenuItem>
                <MenuItem value={"hr_deputy"}>HR-Директор</MenuItem>
                </Select>
                </FormControl>
            )}

            {/* ГАЛОЧКА, КОТОРАЯ ВИДНА ТОЛЬКО ДЛЯ HR-ДИРЕКТОРА */}
            {motivationState === 'hr_deputy' && (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={showArchived}
                            onChange={(e) => setShowArchived(e.target.checked)}
                            name="showArchived"
                            color="primary"
                        />
                    }
                    label="💾 Архив"
                    sx={{ ml: 1.5 }}
                />
            )}
            </Box>

            {/* тут таблица по мотивации админов */}
            {motivationState == "admin" && <TableContainer component={Paper} sx={{ maxHeight: 640 }}>
            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
            <TableRow>
                <TableCell>Сотрудник</TableCell>
                <TableCell>Поступления в кассу</TableCell>
                <TableCell>Кол-во визитов</TableCell>
                <TableCell>Кол-во смен</TableCell>
                <TableCell>Оборот</TableCell>
                <TableCell>Ср. чек</TableCell>
                <TableCell>Ср. чек (План)</TableCell>
                <TableCell>Новый KPI</TableCell>
                <TableCell>Коэф. за кол-во машин</TableCell>
                <TableCell>Коэф. за ср. чек</TableCell>
                <TableCell>ЗП с KPI</TableCell>
                <TableCell>Авансы</TableCell>
                <TableCell>Товары</TableCell>
                <TableCell></TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {adminFinanceInfo.map(({ admin_id, admin_name, total_cash, visits_number, shift_number, services_turnover, average_bill, average_bill_plan, admin_salary_bonus, visits_number_kpi, average_bill_rate, total_salary, advances_sum, goods_sum }) => (
            <TableRow key={admin_id}>
                <TableCell>{admin_name}</TableCell>
                <TableCell>{total_cash}</TableCell>
                <TableCell>{visits_number}</TableCell>
                <TableCell>{shift_number}</TableCell>
                <TableCell>{services_turnover}</TableCell>
                <TableCell>{average_bill}</TableCell>
                <TableCell>{average_bill_plan}</TableCell>
                <TableCell>{admin_salary_bonus}</TableCell>
                <TableCell>{visits_number_kpi}</TableCell>
                <TableCell>{average_bill_rate}</TableCell>
                <TableCell>{total_salary}</TableCell>
                <TableCell>{advances_sum || 0}</TableCell>
                <TableCell>{goods_sum || 0}</TableCell>
            </TableRow>
            ))}
            </TableBody>
            </Table>
            </TableContainer>}

            {/* тут таблица по мотивации кассиров */}
            {motivationState == "cashier" && <TableContainer component={Paper} sx={{ maxHeight: 640 }}>
            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
            <TableRow>
                <TableCell>Сотрудник</TableCell>
                {/* <TableCell>Поступления в кассу</TableCell> */}
                <TableCell>Кол-во визитов</TableCell>
                <TableCell>Кол-во смен</TableCell>
                <TableCell>ЗП за товары</TableCell>
                <TableCell>Кол-во мотив. товаров</TableCell>
                <TableCell>Мотивация</TableCell>
                <TableCell>Итоговый KPI</TableCell>
                <TableCell>Авансы</TableCell>
                <TableCell>Товары</TableCell>
                <TableCell></TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {cashierFinanceInfo.map(({ cashier_id, cashier_name, total_cash, visits_number, shift_number, kpi, total_goods_salary, progressive_product_count, progressive_motivation_bonus, advances_sum, goods_sum }) => (
            <TableRow key={cashier_id}>
                <TableCell>{cashier_name}</TableCell>
                {/* <TableCell>{total_cash}</TableCell> */}
                <TableCell>{visits_number}</TableCell>
                <TableCell>{shift_number}</TableCell>
                <TableCell>{total_goods_salary}</TableCell>
                <TableCell>{progressive_product_count}</TableCell>
                <TableCell>{progressive_motivation_bonus}</TableCell>
                <TableCell>{kpi}</TableCell>
                <TableCell>{advances_sum || 0}</TableCell>
                <TableCell>{goods_sum || 0}</TableCell>
            </TableRow>
            ))}
            </TableBody>
            </Table>
            </TableContainer> }

            {/* тут таблица по мотивации контроля качества */}
            {motivationState == "quality_control" && <TableContainer component={Paper} sx={{ maxHeight: 640 }}>
            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
            <TableRow>
                <TableCell>Сотрудник</TableCell>
                <TableCell>Кол-во визитов</TableCell>
                <TableCell>Кол-во смен</TableCell>
                <TableCell>Ср. чек</TableCell>
                <TableCell>Норма</TableCell>
                <TableCell>ЗП</TableCell>
                <TableCell>KPI</TableCell>
                <TableCell>Штрафы</TableCell>
                <TableCell>Премии</TableCell>
                <TableCell>ЗП c KPI</TableCell>
                <TableCell>Авансы</TableCell>
                <TableCell>Товары</TableCell>
                <TableCell></TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {qualityControlFinanceInfo.map(({ quality_control_id, quality_control_name, visits_number, shift_number, average_check, normal_amount, kpi, fines, bonuses, salary_without_kpi, salary, advances_sum, goods_sum }) => (
            <TableRow key={quality_control_id}>
                <TableCell>{quality_control_name}</TableCell>
                <TableCell>{visits_number}</TableCell>
                <TableCell>{shift_number}</TableCell>
                <TableCell>{average_check}</TableCell>
                <TableCell>{normal_amount}</TableCell>
                <TableCell>{salary_without_kpi}</TableCell>
                <TableCell>{kpi}</TableCell>
                <TableCell>{fines}</TableCell>
                <TableCell>{bonuses}</TableCell>
                <TableCell>{salary}</TableCell>
                <TableCell>{advances_sum || 0}</TableCell>
                <TableCell>{goods_sum || 0}</TableCell>
            </TableRow>
            ))}
            </TableBody>
            </Table>
            </TableContainer> }

            {motivationState === "hr_deputy" && (
                <TableContainer component={Paper} sx={{ maxHeight: 640 }}>
                    <Table stickyHeader sx={{ minWidth: 650 }} aria-label="washer motivation table">
                        <TableHead>
                            <TableRow>
                                <TableCell>ФИО Мойщика</TableCell>
                                <TableCell align="right">Кол-во машин</TableCell>
                                <TableCell align="right">Кол-во смен</TableCell>
                                <TableCell align="right">Оборот</TableCell>
                                <TableCell align="right">Ср. чек</TableCell>
                                <TableCell align="right">ЗП</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {washerMotivationInfo.map((washer) => (
                                <TableRow key={washer.worker_id}>
                                    <TableCell component="th" scope="row">
                                        {washer.full_name}
                                    </TableCell>
                                    <TableCell align="right">{washer.car_count}</TableCell>
                                    <TableCell align="right">{washer.shift_count}</TableCell>
                                    <TableCell align="right">{washer.services_turnover.toLocaleString('ru-RU')} ₽</TableCell>
                                    <TableCell align="right">{washer.average_check.toLocaleString('ru-RU')} ₽</TableCell>
                                    <TableCell align="right">{washer.total_salary.toLocaleString('ru-RU')} ₽</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </>
    )
}
